<template>
  <div>
    <Modal size="md" is-open @close="close">
      <HelperViewStatus
        v-if="!showErrorDeleteModal"
        status="alert"
        title="Tem certeza que deseja encerrar sua conta?"
        description="Ao encerrar, você perderá permanentemente o acesso a todos os seus dados cadastrais e de investimentos. Essa ação é irreversível."
      />
      <HeadingDisplay
        v-if="showErrorDeleteModal"
        class="modal-heading-display"
        title="Ainda não é possível encerrar sua conta"
        :subtitle="errorDeleteModalSubtitle"
        size="small"
      />
      <template #buttonContainer>
        <ButtonContainer v-if="!showErrorDeleteModal">
          <template #button-primary>
            <ButtonPrimary label="Manter minha conta" @click="close" />
          </template>
          <template #button-secondary>
            <ButtonSecondary label="Encerrar conta" @click="deleteConfirm" />
          </template>
        </ButtonContainer>
        <ButtonContainer v-if="showErrorDeleteModal">
          <template #button-primary>
            <ButtonPrimary label="Entendi" @click="close" />
          </template>
        </ButtonContainer>
      </template>
    </Modal>
    <Notification group="wrn-notification-delete-account" />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Emit } from 'vue-property-decorator';
import { Notification } from '@/modules/common/components/Notification';
import { deleteAccount } from '@/modules/common/services/http/account';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import {
  HelperViewStatus,
  Modal,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  HeadingDisplay
} from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    Modal,
    ButtonContainer,
    ButtonPrimary,
    ButtonSecondary,
    HeadingDisplay,
    HelperViewStatus,
    Notification
  }
})
export default class DeleteAccount extends Vue {
  private showErrorDeleteModal = false;
  private errorDeleteModalSubtitle = '';

  @Emit()
  private close() {}

  private async deleteConfirm() {
    deleteAccount().then(
      () => {
        this.$notify({
          group: 'wrn-notification-delete-account',
          text: 'Conta deletada com sucesso!',
          type: NotificationTypes.success
        });
        setTimeout(() => {
          this.$router.push({ name: 'signin' });
        }, 1000);
      },
      err => {
        if (err.message === 'customer_balance_not_zero') {
          this.errorDeleteModalSubtitle =
            'Sua conta só pode ser encerrada após o resgate de todo o dinheiro que você tem investido na Warren.';
        } else {
          this.errorDeleteModalSubtitle =
            'Sua conta tem pendências e não pode ser encerrada neste momento. Se precisar de ajuda, entre em contato com nosso atendimento.';
        }
        this.shouldShowErrorDeleteModal();
      }
    );
  }

  private shouldShowErrorDeleteModal() {
    this.showErrorDeleteModal = true;
  }
}
</script>

<style scoped lang="less">
.modal-heading-display {
  text-align: left !important;
}
</style>
